export default {
  path: '/empresa',
  name: 'Company',
  component: () => import('../../views/Company/CompanyMaster.vue'),
  meta: {
    disableScrollToTop: true,
    isCompany: true,
    hideChrome: true,
  },
  children: [
    {
      path: '',
      redirect: { name: 'CompanyDashboard' },
    },
    {
      path: 'dashboard',
      name: 'CompanyDashboard',
      component: () => import('../../views/Company/CompanyDashboard.vue'),
    },
    {
      path: 'perfil',
      name: 'CompanyProfile',
      component: () => import('../../views/Company/CompanyProfile.vue'),
    },
    {
      path: 'resumo',
      name: 'CompanyResume',
      component: () => import('../../views/Company/CompanyResume.vue'),
    },
    {
      path: 'cadastrar-vaga',
      name: 'JobPost',
      component: () => import('../../views/Job/JobPost.vue'),
    },
    {
      path: 'vagas',
      name: 'JobsCompany',
      component: () => import('../../views/Company/JobsCompany.vue'),
    },
    {
      path: 'indicacoes',
      name: 'IndicationsReceivedCompany',
      component: () => import('../../views/Company/IndicationsReceivedCompany.vue'),
    },
    {
      path: 'vagas/cadastrar-vagas',
      name: 'PostJobCompany',
      component: () => import('../../views/Company/PostJobCompany.vue'),
    },
    {
      path: 'vagas/:jobId/detalhes',
      name: 'JobCompanyDetails',
      component: () => import('../../views/Company/JobCompanyDetails.vue'),
      meta: {
        tabActive: 1,
      },
    },
    {
      path: 'vagas/:jobId/detalhes/indicacoes',
      name: 'JobCompanyDetailsIndications',
      component: () => import('../../views/Company/JobCompanyDetails.vue'),
      meta: {
        tabActive: 2,
      },
    },
    {
      path: 'vagas/:jobId/detalhes/indicacoes/:indicationId/detalhes',
      name: 'IndicationCompanyJobDetails',
      component: () => import('../../views/Company/IndicationCompanyJobDetails.vue'),
    },
    {
      path: 'vagas/:jobId/detalhes/indicacoes/:indicationId/detalhes/historico',
      name: 'IndicationHistoryDetails',
      component: () => import('../../views/Company/IndicationHistory.vue'),
    },
    {
      path: 'historico-indicacoes/:indicationId',
      name: 'IndicationHistory',
      component: () => import('../../views/Company/IndicationHistory.vue'),
    },
    {
      path: 'extrato',
      name: 'CompanyExtract',
      component: () => import('../../views/Company/Extract/CompanyExtract.vue'),
    },
  ],
}
